import { useCallback, useState } from 'react';
import apiClient from '@utils/api-client';
import { apiInternalGenericEventPath } from '../../routes';
const useDeleteGenericEvent = (id) => {
    const [deleting, setDeleting] = useState(false);
    const [error, setError] = useState();
    const [result, setResult] = useState();
    const deleteGenericEvent = useCallback((params) => {
        return new Promise((resolve, reject) => {
            var _a;
            const controller = new AbortController();
            setDeleting(true);
            apiClient
                .delete(apiInternalGenericEventPath(id), {
                params: { deleteFutureEvents: (_a = params.deleteFutureEvents) !== null && _a !== void 0 ? _a : false },
                signal: controller.signal
            })
                .then((response) => {
                const deleteResult = response.data.data;
                setResult(deleteResult.genericEventIds);
            })
                .catch((err) => {
                if (!controller.signal.aborted) {
                    setResult(undefined);
                    setError(err);
                }
            })
                .finally(() => {
                if (!controller.signal.aborted) {
                    setDeleting(false);
                }
            });
        });
    }, [id]);
    return { deleteGenericEvent, deleting, error, result };
};
export default useDeleteGenericEvent;
